function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_3586",
  "data-name": "Group 3586",
  transform: "translate(-326 -231)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  cx: "26",
  cy: "26",
  r: "26",
  transform: "translate(326 231)",
  fill: "#1fb9cb"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3592",
  "data-name": "Group 3592",
  transform: "translate(337 242)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_397",
  "data-name": "Path 397",
  d: "M0 0h30v30H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_398",
  "data-name": "Path 398",
  d: "M5.676 26.993l-.026.027-.027-.027H3.29A1.308 1.308 0 012 25.67V4.324A1.317 1.317 0 013.29 3h23.42A1.307 1.307 0 0128 4.324V25.67a1.317 1.317 0 01-1.29 1.324zM25.4 19V5.666H4.6v18.661L17.6 11zm0 3.77l-7.8-8-9.324 9.56H25.4zm-15.6-9.1A2.667 2.667 0 1112.4 11a2.634 2.634 0 01-2.6 2.664z",
  fill: "#fff"
})))));